import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ICampaign } from '../../../../shared/models/campaign.model';
import { IGTM, ISystemEvent } from '../../../../shared/models/events.model';
import { EventsService, UtilService, CampaignService, VariablesService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-advance-detail',
  templateUrl: './advance-detail.component.html',
  styleUrls: ['./advance-detail.component.scss']
})
export class AdvanceDetailComponent implements OnInit {

  advanceForm: FormGroup;
  desc: FormControl;
  city: FormControl;
  mobile: FormControl;
  isLoading = false;
  @Input() draft: ICampaign;
  @Input() info;
  @Input() param;
  address = {
    address_1: '',
    address_2: '',
    address_3: ''
  };
  type;
  ShowPopover;

  constructor(
    public campaignService: CampaignService,
    private util: UtilService,
    private events: EventsService,
    private vars: VariablesService,
    private actRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: any
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
    this.getCampaignType();
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.type = this.actRoute.snapshot.queryParams['type'];
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      if (res.shortdescription) {
        this.patchForm(res);
      }
    });
  }
  /**Get the type of the campaign */
  getCampaignType() {
    this.util.campaignType$.subscribe((res) => {
      this.type = res;
    });
  }
  /**
  //  * Init the form
   */
  initForm() {
    this.advanceForm = new FormGroup({
      desc: this.desc = new FormControl('', [Validators.required, Validators.minLength(10)]),
      city: this.city = new FormControl('', Validators.required),
      mobile: this.mobile = new FormControl('', [Validators.required]),
    });
    if (!this.mobile.value) {
      this.getNumber();
    }
  }
  /**Error messages */
  getErrorMessage(control: FormControl) {
    switch (true) {
      case control.hasError('required'):
        return this.info.fieldRequired;
      case control.hasError('minlength'):
        return this.info.short_description;
    }
  }
  /**Get mobile number from storage */
  getNumber() {
    const no = this.util.getUserData()?.phone_1;
    if (no) {
      this.mobile.setValue(no);
    }
  }
  /**Submit form */
  submit() {
    if (this.advanceForm.valid) {
      this.isLoading = true;
      const payload = {
        'shortdescription': {
          'entity_type': 'campaign',
          'info_1': this.desc.value,
          'info_type': 'about'
        },
        'address_1': this.address.address_1,
        'address_2': this.address.address_2,
        'address_3': this.address.address_3,
        'owner': {
          'phone_1': this.mobile.value
        }
      };
      this.updateCampaign(payload, this.draft.id);
    } else {
      this.util.checkValidForm(this.advanceForm);
    }
  }
  /**Submit button click mock */
  submitButton() {
    this.document.getElementById('submitBtn3').click();
  }
  /**Patch form */
  patchForm(data) {
    this.address.address_1 = data.address_1;
    this.address.address_2 = data.address_2;
    this.address.address_3 = data.address_3;
    this.advanceForm.patchValue({
      'desc': data.shortdescription.info_1,
      'city': data.address_1 + ', ' + data.address_2 + ', ' + data.address_3,
      'mobile': data.owner.phone_1,
    });
  }

  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    this.campaignService.updateCampaign(payload, id).subscribe(
      (res: any) => {
        res.data.shortdescription = payload['shortdescription'];
        this.util.addObject(res.data, this.draft);
        this.vars.draftObs.next(this.draft);
        this.gtmPush();
        this.sendSystemEvent();
        this.isLoading = false;
        this.util.navigateToForm('desc', this.type, this.draft.id);
      }
    );
  }
  /**Get the address object from place directive */
  getPlace(event) {
    this.address = event;
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step3_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step3',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload.event_type_id = +this.draft?.id;
    }
    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step3_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }
}
